import React from "react";
import Headline from "~/assets/js/components/Typography/Headline";
import i18n from "~/assets/js/Helpers/i18n";
import NutrientDressingCard from "./NutrientDressingCard";
import { getDressingsFromTemplate } from "~/assets/js/Api/ingredientsApi";
import { isSauceFilter } from "../../../Konfigurator/IngredientPage/filters";

const NutrientDressings = ({ isSauceProduct }) => {
    const allDressings = getDressingsFromTemplate();
    const dressings = allDressings.filter((ingredient) =>
        isSauceProduct ? isSauceFilter(ingredient) : !isSauceFilter(ingredient)
    );
    return (
        <>
            <Headline size={6} resizable>
                {isSauceProduct
                    ? i18n.t("nutrients.sauces.title")
                    : i18n.t("nutrients.dressings.title")}
            </Headline>
            <div className="nutrient-dressings">
                {dressings.map((dressing) => {
                    return (
                        <NutrientDressingCard
                            key={dressing.product_id}
                            dressing={dressing}
                        />
                    );
                })}
            </div>
        </>
    );
};

export default NutrientDressings;
